import type { WasteTypeWithMaterials } from '../types/dashboard.type';

export function isOtherWasteTypeKey(wasteType: string): boolean {
  return wasteType.replace(/_/g, '').toLowerCase() === 'other';
}

export interface RecycledWasteChartLabels {
  /** Prefix for materials nested under the "other" waste type. */
  other: string;
  /** Label for "other" mass not attributed to a listed material. */
  remainder: string;
}

const DEFAULT_LABELS: RecycledWasteChartLabels = { other: 'Other', remainder: 'Other (remainder)' };

/**
 * Pie / bar data: one slice per non-other type; "other" with materials becomes one slice per material
 * (plus optional remainder) so the chart reflects the full breakdown.
 */
export function flattenRecycledWasteForChart(
  rows: WasteTypeWithMaterials[],
  labels: RecycledWasteChartLabels = DEFAULT_LABELS,
): { waste_type: string; total_kg: number }[] {
  const out: { waste_type: string; total_kg: number }[] = [];

  for (const row of rows) {
    if (isOtherWasteTypeKey(row.waste_type) && row.materials?.length) {
      for (const mat of row.materials) {
        if (mat.amount > 0) {
          out.push({
            waste_type: `${labels.other} — ${mat.material_type}`,
            total_kg: mat.amount,
          });
        }
      }
      const matSum = row.materials.reduce((s, m) => s + m.amount, 0);
      const remainder = row.total_kg - matSum;
      if (remainder > 0.001) {
        out.push({ waste_type: labels.remainder, total_kg: remainder });
      }
    } else {
      out.push({
        waste_type: row.waste_type.replace(/_/g, ' '),
        total_kg: row.total_kg,
      });
    }
  }

  return out;
}
